module.exports = __webpack_public_path__ + "68c424db4ce39675e58b662b331de9ea.jpg";